module.exports = __webpack_public_path__ + "img/qualified.9430ed5a.svg";